import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnInit,
    inject,
    viewChild,
    input,
    output,
} from '@angular/core'
import { ColorPickerService } from '@app/shared/color-picker/color-picker.service'
import { IconPickerService } from '@app/shared/icon-picker/icon-picker.service'
import { SetType } from '@app/shared/models/picker'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TbPickerComponent } from '@components-library/tb-picker/tb-picker.component'

export type PickerIcon = {
    icon: string | null
    isDefault?: boolean
}

@Component({
    selector: 'app-icon-picker',
    templateUrl: './icon-picker.component.html',
    styleUrl: './icon-picker.component.sass',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TbPickerComponent, TbIconComponent, TbButtonComponent],
})
export class IconPickerComponent implements OnInit {
    private readonly iconPickerService = inject(IconPickerService)
    private readonly colorPickerService = inject(ColorPickerService)

    private triggerItem = viewChild.required<ElementRef>('triggerItem')

    set = input.required<SetType>()
    subtitle = input.required<string>()
    name = input<string>()
    icon = input<string>()
    iconColor = input<string>()

    iconChange = output<PickerIcon>()

    pickerItems!: string[]

    filled = false

    defaultStatusIcon!: string
    selectedIcon!: string | null
    defaultColor!: string

    ngOnInit() {
        this.pickerItems = this.iconPickerService.getIcons()
        this.filled = this.iconPickerService.getIconFill(this.set())
        this.defaultStatusIcon = this.iconPickerService.getDefaultIcon(SetType.STATUS)
        this.defaultColor = this.getDefaultColor()

        this.selectedIcon = this.getIcon()

        if (!this.icon()) {
            this.iconChange.emit({ icon: this.selectedIcon, isDefault: true })
        }
    }

    getDefaultColor() {
        if (this.set() === SetType.STATUS) return ''

        return this.colorPickerService.getDefaultColor(this.set())
    }

    selectIcon(icon: string | null) {
        this.selectedIcon = icon ?? this.defaultStatusIcon
        this.iconChange.emit({ icon })
    }

    open() {
        this.triggerItem().nativeElement.click()
    }

    private getIcon() {
        const icon = this.icon()
        if (!icon) {
            return this.iconPickerService.getDefaultIcon(this.set())
        }

        return icon
    }

    protected readonly SetType = SetType
}
